import { translate } from "app/filters/i18nFilter";
import type { IDevicesConfig } from "./deviceDistributionTypes";
import { CHART_COLORS } from "app/constants/ChartColors";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const DONUT_INNER_SIZE = "60%";
export const WIDGET_TITLE_KEY = "keyword.analysis.overview.page.v2.device_distribution.title";
export const WIDGET_TOOLTIP_KEY = "keyword.analysis.overview.page.v2.device_distribution.tooltip";
const DEVICE_DISTRIBUTION_ENDPOINT = "api/KeywordAnalysis/Overview/SERPComposition";

const colors = CHART_COLORS.mobileDesktopColors;

export const devicesConfig: IDevicesConfig[] = [
    {
        get name() {
            return translate("keyword.analysis.overview.page.v2.device_distribution.desktop");
        },
        color: colors[0],
        visible: true,
        id: devicesTypes.DESKTOP,
    },
    {
        get name() {
            return translate("keyword.analysis.overview.page.v2.device_distribution.mobile_web");
        },
        color: colors[1],
        visible: true,
        id: devicesTypes.MOBILE,
    },
];
